module.exports = __webpack_public_path__ + "static/HP-logo-45cba1d3f0b83d3dc16870d3019097a9.png";